import { render, staticRenderFns } from "./OverallDataMinimal.vue?vue&type=template&id=ad022610&scoped=true&"
import script from "./OverallDataMinimal.vue?vue&type=script&lang=js&"
export * from "./OverallDataMinimal.vue?vue&type=script&lang=js&"
import style0 from "./OverallDataMinimal.vue?vue&type=style&index=0&id=ad022610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad022610",
  null
  
)

export default component.exports